export default {
  // SOLUTIONS
  'easy_patient_transportation': {
    heading: 'Ergonomic Drive that Goes the Distance',
    description: `<br><h3>i-Drive Power®</h3>Reduces transport related MSD costs by up to 80%.<br><br>
    <h3>FlexiDrive®</h3>Improves stretcher maneuverability in crowded or challenging environments with its retractable design and shock absorber.<br><br>
    <h3>IV&Drive®</h3>Allows the stretcher to be moved from any height without compromising ergonomic posture.`,
    video: 'sprint400/EasyPatienttransport.mp4',
    videoPoster: 'sprint400/EasyPatienttransport.jpg'
  },
  'fall_prevention': {
    heading: 'Safety Proven in Million Carebeds',
    description: `<br>
    <h3>Multizone bed exit alarm</h3>
    Notifies staff when a patient leaves the stretcher.<br><br>
    <h3>Ergoframe® </h3>
    reduces the peak pressure in pelvic area by 16%.<br><br>
    <h3>Mobi-Lift® </h3>
    Provides support for patients as they get off the stretcher.<br><br>
    <h3>Scales </h3>
    Provide accuracy up to 0.5 kg (1.1 lb) and eliminate the need of transferring the patient to another surface.`,
    video: 'sprint400/FallsPrevention.mp4',
    videoPoster: 'sprint400/FallsPrevention.jpg'
  },
  'simplify_caregiver_procedures': {
    heading: 'Empowered Patient Comfort, Utmost Efficiency in Care',
    description: `<br>
    <h3>Electric Positioning</h3>
    Reduces physical strain on caregivers during patient repositioning.<br><br>
    <h3>Accessories compatibility</h3>
    Ensures streamlined workflows across departments and minimizes issues from incompatibility.<br><br>
    <h3>USB integration</h3>
    Allows easy and safe charging of patient‘s phone.`,
    video: 'sprint400/SimplifyCaregiverprocedures.mp4',
    videoPoster: 'sprint400/SimplifyCaregiverprocedures.jpg'
  },

  // KEY FEATURES
  'transportation': {
    heading: 'Transportation',
    subExplanations: [
      'idrive',
      'ivdrive',
      'flexidrive',
      'easybrake'
    ]
  },
  'idrive': {
    heading: 'i-Drive Power® with SafetySense®',
    description: 'Patient transport can be physically demanding — but with i-Drive Power®, it\'s taken to a whole new level. Sprint 400 can travel up to 11 km with just the push of a button. A built-in SafetySense® ensures that if the button no longer detects a hand, the stretcher stops.',
    images: [
      'sprint400/i-Drive_Power.jpg'
    ],
    camera: {
      orbit: '10rad 1.22rad 10%',
      target: '-100m 100m 34m'
    },
  },
  'ivdrive': {
    heading: 'IV&Drive',
    description: 'With the innovative IV&Drive® concept, IV poles and push handles are seamlessly integrated, allowing the stretcher to be pushed from any height without compromising ergonomic posture. Designed for durability, the IV poles remain intact under all standard conditions.',
    images: [
      'sprint400/IV_Drive.jpg'
    ],
    camera: {
      orbit: '5rad 1.475rad 40%',
      target: '-94m 86m 30m'
    },
  },
  'flexidrive': {
    heading: 'FlexiDrive®',
    description: 'Sprint 400 can be equipped with a retractable 5th wheel featuring a shock absorber, making steering easier.',
    images: [
      'sprint400/Flexidrive.jpg'
    ],
    camera: {
      orbit: '-180deg 1.31rad 20%',
      target: '-20m 10m 0'
    }
  },
  'easybrake': {
    heading: 'EasyBrake®',
    description: 'Foot levers on all sides allow caregivers to easily activate or release the brakes. The ergonomic design ensures visibility and comfort.',
    images: [
      'sprint400/EasyBrake.jpg'
    ],
    camera: {
      orbit: '-90deg 60deg 20%',
      target: '-70m 20m 10m'
    },
  },
  'zerogap_siderails': {
    heading: 'Zerogap siderails',
    description: 'Engineered to eliminate gaps between surfaces, it ensures seamless and efficient patient transfers, significantly reducing the risk of falls and improving handling in critical care situations.',
    images: [
      'sprint400/ZeroGap.jpg'
    ],
    camera: {
      orbit: '-6.89rad 1.41rad 40%',
      target: '0 0 0'
    },
  },

  'safety': {
    heading: 'Safety',
    subExplanations: [
      'ergoframe',
      'bed_exit_alarm',
      'scales',
      'mobilift',
      'softdrop_siderails',
      'zerogap_siderails',
    ]
  },
  'bed_exit_alarm': {
    heading: 'Multizone Bed Exit Alarm',
    description: 'Caregivers can’t be everywhere. The multizone bed exit feature helps prevent falls by alerting them even when the patient is unattended.',
    images: [
      'sprint400/Bed_Exit_Alarm.jpg'
    ],
    camera: {
      orbit: '90deg 40deg 10%',
      target: '90m 60m -15m'
    },
  },
  'softdrop_siderails': {
    heading: 'Softdrop siderails',
    description: 'The design allows the siderails to lower smoothly and silently, minimizing the risk of hand entrapment.',
    images: [
      'sprint400/Softdrop_siderails.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-30m 60m -20m'
    },
  },
  'mobilift': {
    heading: 'Mobi-lift®',
    description: 'When exiting the stretcher, a patient is at increased risk of falling without support. The Mobilift handle provides stability and support during this transition.',
    images: [
      'sprint400/Mobi-Lift.jpg'
    ],
    camera: {
      orbit: '140deg 80deg 30%',
      target: '80m 70m -40m'
    },
  },
  'ergoframe': {
    heading: 'Ergoframe®',
    description: 'To enhance patient comfort during positioning, Ergoframe reduces peak pressure in the pelvic area by 16%.',
    images: [
      'sprint400/Ergoframe.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-30m 60m -20m'
    },
  },
  'mobigrips': {
    heading: 'Mobigrips',
    description: 'The unique integrated Mobigrip in the siderails can help the patient with self-mobilization in stretcher, preventing immobilization which can lead to increased risk of pressure injury development.',
    images: [
      'sprint400/Mobi-Grips.jpg'
    ],
    camera: {
      orbit: '-9.88rad 1.31rad 40%',
      target: '-60m 70m 20m'
    },
  },

  'efficiency': {
    heading: 'Efficiency',
    subExplanations: [
      'electric_positioning',
      'integrated_usb_port'
    ],
  },
  'electric_positioning': {
    heading: 'Electric positioning',
    description: 'Caregivers can effortlessly adjust the backrest and thigh rest at the push of a button, eliminating the need for manual repositioning. By minimizing physical effort, it reduces musculoskeletal strain and saves time—allowing caregivers to focus on more critical tasks. It also empowers patients to adjust their position independently, promoting autonomy and enhancing their overall care experience.',
    images: [
      'sprint400/electric_positioning.jpg'
    ],
    camera: {
      orbit: '170deg 70deg 20%',
      target: '0m 100m 0'
    },
  },
  'integrated_usb_port': {
    heading: 'Integrated USB port',
    description: 'Allows patients on the stretcher to safely and conveniently charge their phones, enhancing the overall care experience and providing a sense of normalcy during recovery.',
    images: [
      'sprint400/integrated_usb_port.jpg'
    ],
    camera: {
      orbit: '-180deg 80deg 10%',
      target: '-60m 80m 0'
    },
  },
  'scales': {
    heading: 'Scales',
    description: 'Precise weight measurements with up to 0.5 kg (1.1 lb) accuracy help prevent medication overdoses and eliminate the need to transfer patients to another surface.',
    images: [
      'sprint400/Scales.jpg'
    ],
    camera: {
      orbit: '90deg 40deg 10%',
      target: '90m 60m -15m'
    },
  },

  'positions': {
    heading: 'Positions',
    subExplanations: [
      'cardiac',
      'trendelenburg',
      'vascular_leg',
    ]
  },
  'cardiac': {
    heading: 'Cardiac chair',
    description: 'Essential for patient comfort—especially during recovery—it supports improved breathing and cardiovascular function, making it ideal for post-cardiac care and respiratory support.',
    images: [
      'sprint400/Cardiac_chair.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'vascular_leg': {
    heading: 'Vascular leg',
    description: 'The ergonomic vascular leg position is designed to support lower extremity exercises and stretching, promoting circulation and aiding recovery for patients with vascular or mobility challenges.',
    images: [
      'sprint400/Vascular_leg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'trendelenburg': {
    heading: 'Trendelenburg',
    description: 'The Sprint 400 offers up to 17 degrees of tilt, supporting both Trendelenburg and reverse Trendelenburg positions. This enhances versatility for a wide range of medical needs, including circulatory and respiratory support.',
    images: [
      'sprint400/Trendelenburg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'anti-trendelenburg': {
    heading: 'Anti-trendelenburgg',
    description: '',
    images: [
      'sprint400/Anti-Trendelenburg.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },
  'semi-fowler': {
    heading: 'Semi-fowler',
    description: '',
    images: [
      'sprint400/Semi_Fowler.jpg'
    ],
    camera: {
      orbit: '-6.29rad 1.33rad 65%',
      target: '25m 40m 0m'
    },
  },

  'accessories': {
    heading: 'Accessories',
    subExplanations: [
      'foot_support',
      'head_support',
      'iv_poles',
      '3-in-1_shelf',
      'vertical_oxygen_bottle_holder',
      'paper_roll_holder',
      // 'notes_holder',
      // 'multifunctional_box'
    ]
  },
  'foot_support': {
    heading: 'Foot Support',
    description: '',
    images: [
      'sprint400/foot_support.jpg'
    ]
  },
  'head_support': {
    heading: 'Head Support',
    description: '',
    images: [
      'sprint400/head_support.jpg'
    ]
  },
  'iv_poles': {
    heading: 'IV Poles',
    description: '',
    images: [
      'sprint400/iv_poles.jpg'
    ]
  },
  '3-in-1_shelf': {
    heading: '3-in-1 shelf',
    description: '',
    images: [
      'sprint400/3-in-1_Shelf.jpg'
    ]
  },
  'vertical_oxygen_bottle_holder': {
    heading: 'Vertical oxygen bottle holder',
    description: '',
    images: [
      'sprint400/Vertical_oxygen_bottle_holder.jpg'
    ]
  },
  'paper_roll_holder': {
    heading: 'Paper roll holder',
    description: '',
    images: [
      'sprint400/Paper_roll_holder.jpg'
    ]
  },
  'notes_holder': {
    heading: 'Notes holder',
    description: '',
    images: [
      'sprint400/Notes_holder.jpg'
    ]
  },
  'multifunctional_box': {
    heading: 'Multifunctional box',
    description: '',
    images: [
      'sprint400/Multidunctional_box.jpg'
    ]
  },
}
